import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoTwitter = () => {
  return (
    <g>
      <path d="m15.6 3.2859a6.2331 6.2331 0 0 1 -1.791.491 3.1278 3.1278 0 0 0 1.371-1.7252 6.2435 6.2435 0 0 1 -1.98.7567 3.1214 3.1214 0 0 0 -5.314 2.8443 8.8531 8.8531 0 0 1 -6.4278-3.2583 3.1219 3.1219 0 0 0 .9651 4.1634 3.1063 3.1063 0 0 1 -1.4125-.39v.0393a3.12 3.12 0 0 0 2.5012 3.0577 3.1237 3.1237 0 0 1 -1.4083.0535 3.1214 3.1214 0 0 0 2.9131 2.1656 6.2564 6.2564 0 0 1 -3.8729 1.335 6.328 6.328 0 0 1 -.7439-.0437 8.8264 8.8264 0 0 0 4.78 1.4011 8.8122 8.8122 0 0 0 8.873-8.8727q0-.2028-.009-.4034a6.3362 6.3362 0 0 0 1.556-1.6143z" />
    </g>
  );
};

export default withIcon(IconLogoTwitter);
